import { setEditMapModalOpen } from "../../../reducers/ownApp";
import { useDispatch, useSelector } from "react-redux";

import { Modal } from "../Modal";
import { EditMapModalActions } from "./EditMapModalActions";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { editMapModalOpenSelector } from "../../../reducers/ownApp/selectors";
import { lockDepot } from "../../../reducers/depot/thunkActions";
import { setMatrixProfileOptions } from "../../../reducers/matrixProfile/thunkActions";
import {
  setHeatmapView,
  setSelectedOverlay,
} from "../../../reducers/matrixProfile";

const useStyles = makeStyles({
  text: {
    fontSize: "16px",
    lineHeight: "20px",
    marginTop: "10px",
  },
});

export const EditMapModal = () => {
  const dispatch = useDispatch();
  const styles = useStyles();
  const editMapModalOpen = useSelector(editMapModalOpenSelector);

  const closeClick = () => {
    dispatch(setEditMapModalOpen(false));
  };

  const continueClick = () => {
    dispatch(setEditMapModalOpen(false));
    dispatch(setMatrixProfileOptions());
    dispatch(setSelectedOverlay(null));
    dispatch(setHeatmapView(false));
    dispatch(lockDepot());
  };

  return (
    <>
      <Modal
        maxWidth={"xs"}
        open={editMapModalOpen}
        onClose={closeClick}
        title={"Edit Map"}
        content={
          <Typography className={styles.text}>
            Are you sure? Continuing will automatically unlock any plans
            currently being edited for this depot and all unsaved changes will
            be lost
          </Typography>
        }
        actions={
          <EditMapModalActions
            onCancel={closeClick}
            onContinue={continueClick}
          />
        }
        minWidth={500}
      />
    </>
  );
};
